import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';

export default function ClaimDetailsPLNAR(props: any) {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography
          sx={{
            marginTop: '1rem',
            marginLeft: '1rem',
            marginBottom: '1rem',
          }}
          variant="body1"
        >
          Check your mobile phone or your email for the link to download and use Plnar Snap. Reach out to your adjuster
          if you have any questions.
        </Typography>
      </Grid>
    </Grid>
  );
}
